import { RouteErrorScreen } from '@slims/ui';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

/**
 * `errorElement` della rotta radice (INB-192): senza di esso qualunque errore di
 * render risaliva al fallback di React Router ("Unexpected Application Error!"),
 * mostrando lo stack minificato all'utente. Cattura gli errori di tutte le rotte
 * figlie: la navigazione verso la dashboard resetta il boundary.
 */
export function RouteError() {
	const error = useRouteError();
	const navigate = useNavigate();

	const details = isRouteErrorResponse(error)
		? `${error.status} ${error.statusText}`
		: error instanceof Error
			? error.message
			: null;

	// Log completo in console: la UI mostra solo il messaggio, non lo stack.
	console.error('[route-error]', error);

	return (
		<RouteErrorScreen
			details={details}
			onRetry={() => window.location.reload()}
			onGoHome={() => navigate('/dashboard')}
		/>
	);
}
